import React, { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Mixpanel from 'mixpanel-browser';
import Button from '~/components/Button';
import QuizHeader from '~/components/QuizHeader';
import { createNavigationPath } from '~/core/helpers/navigation';
import { NavigationPath, ScreenProps } from '~/core/dto/navigationDTO';
import girlHeart from '~/assets/images/girlHeart.png';
import Quiz from '~/core/helpers/quiz';

import './QuizIntro.styles.css';
import Spacer from '~/components/Spacer';

const QuizIntro: FC<ScreenProps> = ( { type } ) => {

  const navigate = useNavigate();
  const routeName = `QuizIntro-${type}`;
  const question = Quiz.getNextQuestion( type )?.id;

  const onContinue = () => {

    Mixpanel.track( routeName, { state: 1 } );

    if ( !question ) {

      navigate( type === 'adult' ? NavigationPath.AdultFinancialIQ : NavigationPath.FinancialIQ );

      return;

    }

    navigate( createNavigationPath( type === 'adult' ? NavigationPath.AdultQuizQuestion : NavigationPath.QuizQuestion, question ) );

  };

  useEffect( () => {

    Mixpanel.track( routeName, { state: 0 } );

  }, [] );

  return (
    <div className="container">
      <QuizHeader type={type} progress={1 / ( Quiz.getQuestions( type ).length + 1 )} />
      <div className="scrollContainer">
        <div className="quizIntroContent flexColumn alignCenter">
          <div className="quizIntroCenter flexColumn alignCenter">
            <img src={girlHeart} alt="" />
            <div>
              <h1 className="textCenter">Yay, great you are here!</h1>
              <Spacer size={8} />
              <p className="textCenter">
                {type === 'parent' ? 'We’ll help your child build financial skills. Let’s continue so we can understand you better!' : 'We’ll help you to boost your money skills. Let’s test your financial IQ first!'}
              </p>
            </div>
          </div>
          <Button onPress={onContinue}>Continue</Button>
          <Spacer size={16} />
        </div>
      </div>
    </div>
  );

};

export default QuizIntro;
